import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { EmployeeSettingsSection } from './EmployeeSettingsSection'
import { TriggersSection } from './TriggersSection'

import type { Schema } from './schema'

export const InterstitialSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.interstitial',
  })

  const ability = useAbility()
  const { control, setValue, watch } = useFormContext<Schema>()
  const { availability } = watch()
  const cannotUpdate: boolean = ability.cannot('update', 'Domain')

  const isAvailable: boolean = availability === 'available'

  useEffect(() => {
    if (!isAvailable) {
      setValue('enabled', false)
    }
  }, [isAvailable])

  return (
    <>
      <Paper
        data-cy='section-interstitial'
        sx={{ mt: 0 }}
      >
        <SectionHeader
          subtitle={t('subtitle')}
          title={t('title')}
          titleEndAdornment={
            <Switch
              control={control}
              disabled={cannotUpdate || !isAvailable}
              name='enabled'
              {...(!isAvailable && {
                tooltip: {
                  content: t('tooltip'),
                },
                tooltipMode: 'wrap',
              })}
            />
          }
        />
      </Paper>

      {ability.can('read', 'DomainRichPlacementsFeature-interstitialEmployeeSettings') && (
        <EmployeeSettingsSection />
      )}

      <TriggersSection />
    </>
  )
}
